// extracted by mini-css-extract-plugin
export var banner = "_8y-0";
export var buttonText = "_8y-1";